var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrandma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 97,
    viewBox: "0 0 82 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6015 63.8192V61.4009C57.8488 60.9731 65.3024 59.5622 72.1052 61.9956C69.3547 54.0711 67.6668 45.8215 67.0852 37.4594C66.6193 30.7203 66.85 23.8053 64.6669 17.4046C63.4523 13.7934 61.4548 10.4908 58.8153 7.72951C56.1757 4.96825 52.9584 2.81562 49.39 1.42339C45.7966 0.0937836 41.9233 -0.313279 38.1292 0.239947C34.3351 0.793172 30.7431 2.28877 27.6862 4.58808C25.5887 6.24173 23.702 8.61449 23.9144 11.2634C20.2785 10.0421 16.2255 12.606 14.5252 16.0241C12.8249 19.4421 12.9105 23.4367 13.1503 27.2416C13.8576 38.3909 15.5702 49.8208 12.5392 60.5665L31.4 61.1339V63.8162C18.3383 65.6367 7.13276 71.0756 0 78.5959C5.12584 84.3793 11.4335 89.0119 18.5031 92.1853C25.5726 95.3586 33.2418 97 41 97C48.7582 97 56.4274 95.3586 63.4969 92.1853C70.5665 89.0119 76.8742 84.3793 82 78.5959C74.8672 71.0786 63.6617 65.6352 50.6015 63.8192Z",
    fill: "#FFF8EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrandma);
export default __webpack_public_path__ + "static/media/grandma.9128120fe8702000d26e9eb067a77175.svg";
export { ForwardRef as ReactComponent };